import { useState } from "react";

export default function Indications({ med }) {
    const [expanded, setExpanded] = useState(false);

    const indications = [
        "Analgesic",
        "Sedated Intubation ",
        "Hypotension",
        "Sedation",
        "Nausea/vomiting",
        "Fever",
        "Neurogenic shock",
        "Fluid refractory hypotension",
        "Suspected kidney stone",
        "Dehydration",
        "Acidosis",
        "Crush injury",
        "Compartment syndrome",
        "Hyperkalemia"
    ];

    const changeView = () => setExpanded(e => !e);

    const update = (e) => {
        if (e.target.checked) {
            med.indications.push(e.target.name);
        } else {
            med.indications.splice(med.indications.indexOf(e.target.name), 1);
        }
    }

    return (
        <div className="indications">
            <div className="dropdown" onClick={changeView}>Indications ⮟</div>
            <div className={`checklist ${!expanded ? "hidden" : ""}`}>
                {indications.map((c, idx) => (
                    <div key={c} className="indication">
                        <label>
                            <input 
                                type="checkbox" 
                                onChange={update} 
                                data-type={"generic"}
                                data-index={idx}
                                data-key="indications"
                                name={c}
                                defaultChecked={med.indications.includes(c)}
                            />
                            {c}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    )
}